// * Importing constants for Lobster validation
import {
  AVG_SOAK_TIME_EMPTY,
  AVG_SOAK_TIME_FORMAT,
  AVG_SOAK_TIME_MIN_FORMAT,
  STRINGS_HAULED_EMPTY,
  STRINGS_HAULED_FORMAT,
  TRAPS_IN_WATER_EMPTY,
  TRAPS_IN_WATER_FORMAT,
  LINES_IN_WATER_EMPTY,
  LINES_IN_WATER_FORMAT,
  TRAPS_PER_EFFORT_EMPTY,
  TRAPS_PER_EFFORT_FORMAT,
  TRAPS_PER_STRING_EMPTY,
  TRAPS_PER_STRING_FORMAT,
  LAT_LON_FORMAT_ERROR,
  MINIMUM_DECIMAL_ERROR,
  MINIMUM_LAT_DECIMAL_ERROR,
  MINIMUM_LON_DECIMAL_ERROR,
  LAT_DECIMAL_DEGREES_EMPTY,
  LON_DECIMAL_DEGREES_EMPTY,
} from "./ErrorText";
import { getErrorText } from "./Helpers";

export const getGearCodeValidation = function (gearCode, validationData) {
  if (!gearCode) {
    return false;
  }
  if (!Array.isArray(validationData)) {
    return false;
  }
  for (let e = 0; e < validationData.length; e++) {
    if (validationData[e].CODE === gearCode) {
      return validationData[e];
    }
  }
  return false;
};

export const validateEffortSet1 = function (effortData, validationData) {
  let errors = [];
  if (effortData.gearcode === "") {
    errors[errors.length] = "No Gear code provided";
  }
  if (effortData.gearcode) {
    let gearValidate = getGearCodeValidation(effortData.gearcode, validationData);
    if (!gearValidate) {
      errors[errors.length] = "No validation rule found for this gear";
    }
    if (gearValidate) {
      if (effortData.show_gear_qty === true) {
        if (effortData.gearqty === "") {
          errors[errors.length] = "No Gear quantity provided";
        }
        if (effortData.gearqty !== "") {
          if (
            gearValidate.hasOwnProperty("QUANTITY_MINIMUM") &&
            gearValidate.QUANTITY_MINIMUM !== ""
          ) {
            if (Number(effortData.gearqty) < Number(gearValidate.QUANTITY_MINIMUM)) {
              errors[errors.length] =
                "Gear quantity" +
                " smaller than minimum value (" +
                gearValidate.QUANTITY_MINIMUM +
                ")";
            }
          }
          if (
            gearValidate.hasOwnProperty("QUANITY_MAXIMUM") &&
            gearValidate.QUANITY_MAXIMUM !== ""
          ) {
            if (Number(effortData.gearqty) > Number(gearValidate.QUANITY_MAXIMUM)) {
              errors[errors.length] =
                "Gear quantity" +
                " larger than maximum value (" +
                gearValidate.QUANITY_MAXIMUM +
                ")";
            }
          }
        }
      }
      if (effortData.show_gear_size === true) {
        if (effortData.gearsize === "") {
          errors[errors.length] = "No Gear size provided";
        }
        if (effortData.gearsize !== "") {
          if (
            gearValidate.hasOwnProperty("SIZE_MINIMUM") &&
            gearValidate.SIZE_MINIMUM !== ""
          ) {
            if (Number(effortData.gearsize) < Number(gearValidate.SIZE_MINIMUM)) {
              errors[errors.length] =
                "Gear size" +
                " smaller than minimum value (" +
                gearValidate.SIZE_MINIMUM +
                ")";
            }
          }
          if (
            gearValidate.hasOwnProperty("SIZE_MAXIMUM") &&
            gearValidate.SIZE_MAXIMUM !== ""
          ) {
            if (Number(effortData.gearsize) > Number(gearValidate.SIZE_MAXIMUM)) {
              errors[errors.length] =
                "Gear size" +
                " larger than maximum value (" +
                gearValidate.SIZE_MAXIMUM +
                ")";
            }
          }
        }
      }
      if (effortData.show_mesh_size === true) {
        if (effortData.mesh_size === "") {
          errors[errors.length] = "No Mesh size provided";
        }
        if (effortData.mesh_size !== "") {
          if (
            gearValidate.hasOwnProperty("MESH_MINIMUM") &&
            gearValidate.MESH_MINIMUM !== ""
          ) {
            if (Number(effortData.mesh_size) < Number(gearValidate.MESH_MINIMUM)) {
              errors[errors.length] =
                "Mesh size" +
                " smaller than minimum value (" +
                gearValidate.MESH_MINIMUM +
                ")";
            }
          }
          if (
            gearValidate.hasOwnProperty("MESH_MAXIMUM") &&
            gearValidate.MESH_MAXIMUM !== ""
          ) {
            if (Number(effortData.mesh_size) > Number(gearValidate.MESH_MAXIMUM)) {
              errors[errors.length] =
                "Mesh size" +
                " larger than maximum value (" +
                gearValidate.MESH_MAXIMUM +
                ")";
            }
          }
        }
      }
    }
  }
  return errors;
};

export const validateEffortSet2 = function (effortData, validationData) {
  let errors = [];

  if (effortData.chart_area === "") {
    errors[errors.length] = "No Chart Area provided";
  }

  let gearValidate = getGearCodeValidation(effortData.gearcode, validationData);
  if (!gearValidate) {
    errors[errors.length] = "No validation rule found for this gear";
  }
  if (gearValidate) {
    if (effortData.show_number_of_hauls === true) {
      if (effortData.number_of_hauls === "") {
        errors[errors.length] = "No Number of Hauls provided";
      }
      if (effortData.number_of_hauls !== "") {
        if (isNaN(effortData.number_of_hauls)) {
          errors[errors.length] =
            "Number of Hauls is not numeric (" + effortData.number_of_hauls + ")";
        } else {
          if (
            gearValidate.hasOwnProperty("HAULS_MINIMUM") &&
            gearValidate.HAULS_MINIMUM !== ""
          ) {
            if (Number(effortData.number_of_hauls) < Number(gearValidate.HAULS_MINIMUM)) {
              errors[errors.length] =
                "Number of Hauls" +
                " smaller than minimum value" +
                " (" +
                effortData.number_of_hauls +
                ")";
            }
          }
          if (
            gearValidate.hasOwnProperty("HAULS_MAXIMUM") &&
            gearValidate.HAULS_MAXIMUM !== ""
          ) {
            if (Number(effortData.number_of_hauls) > Number(gearValidate.HAULS_MAXIMUM)) {
              errors[errors.length] =
                "Number of Hauls" +
                " larger than maximum value" +
                " (" +
                effortData.number_of_hauls +
                ")";
            }
          }
        }
      }
    }
    if (effortData.show_soak_time === true) {
      if (effortData.tow_soak_time.hours === "") {
        errors[errors.length] = "No Tow Soak Hours provided";
      }
      if (effortData.tow_soak_time.hours !== "") {
        if (isNaN(effortData.tow_soak_time.hours)) {
          errors[errors.length] =
            "Tow Soak Hours is not numeric (" + effortData.tow_soak_time.hours + ")";
        } else {
          if (!Number.isInteger(Number(effortData.tow_soak_time.hours))) {
            errors[errors.length] =
              "Tow Soak Hours is not an integer" +
              " (" +
              effortData.tow_soak_time.hours +
              ")";
          }
          if (effortData.tow_soak_time.minutes === "") {
            errors[errors.length] = "No Tow Soak Minutes provided";
          }
          if (effortData.tow_soak_time.minutes !== "") {
            if (isNaN(effortData.tow_soak_time.minutes)) {
              errors[errors.length] =
                "Tow Soak Minutes is not numeric" +
                " (" +
                effortData.tow_soak_time.minutes +
                ")";
            } else {
              if (!Number.isInteger(Number(effortData.tow_soak_time.minutes))) {
                errors[errors.length] =
                  "Tow Soak Minutes is not an integer" +
                  " (" +
                  effortData.tow_soak_time.minutes +
                  ")";
              }
              if (
                Number(effortData.tow_soak_time.minutes) < 0 ||
                Number(effortData.tow_soak_time.minutes) > 59
              ) {
                errors[errors.length] = "Tow Soak Minutes is not in a valid range";
              }
              if (
                gearValidate.hasOwnProperty("SOAK_MINIMUM") &&
                gearValidate.SOAK_MINIMUM !== ""
              ) {
                if (
                  Number(effortData.tow_soak_time.hours) <
                    Number(gearValidate.SOAK_MINIMUM) &&
                  Number(effortData.tow_soak_time.minutes) === 0
                ) {
                  errors[errors.length] = "Tow Soak Hours smaller than minimum value";
                }
              }
              if (
                gearValidate.hasOwnProperty("SOAK_MAXIMUM") &&
                gearValidate.SOAK_MAXIMUM !== ""
              ) {
                if (
                  Number(effortData.tow_soak_time.hours) >
                    Number(gearValidate.SOAK_MAXIMUM) ||
                  (Number(effortData.tow_soak_time.hours) ===
                    Number(gearValidate.SOAK_MAXIMUM) &&
                    effortData.tow_soak_time.minutes > 0)
                ) {
                  errors[errors.length] = "Tow Soak Hours larger than maximum value";
                }
              }
            }
          }
        }
      }
    }
  }
  if (effortData.fishing_depth === "") {
    errors[errors.length] = "No Fishing depth provided";
  }
  if (effortData.fishing_depth !== "") {
    if (isNaN(effortData.fishing_depth)) {
      errors[errors.length] = "No valid fishing depth provided";
    } else if (
      Number(effortData.fishing_depth) < 0 ||
      Number(effortData.fishing_depth) > 999
    ) {
      errors[errors.length] = "Fishing depth is not in a valid range";
    }
  }
  return errors;
};

export const validateEffortSet3 = function (effortData) {
  let errors = [];
  let regex_minutes = /^([0-5][0-9]|60|6|[0-9])$/;
  const regex_lat_degrees = /^(-?)([2][3-9]|30|[3-4][2-6]|37|38|39|40|41)$/;
  const regex_long_degrees = /^(-?)([8-9][1-7]|88|89|90|[6-7][4-9]|80|70|71|72|73)$/;
  const regex_dec_degrees = new RegExp(`^(-?)\\d+\\.\\d{4,}$`);
  const regex_latitude =
    /^(-?)([2][3-9]|[3-4][0-6]|37|38|39)(\.)(\d*)$|^(-?)([2][3-9]|[3-4][0-6]|37|38|39)$/;
  const regex_longitude =
    /^(-?)([8-9][1-7]|88|89|90|[6-7][4-9]|80|70|71|72|73)(\.)(\d*)$|^(-?)([8-9][1-7]|88|89|90|[6-7][4-9]|80|70|71|72|73)$/;

  if (effortData.lat_long_format === "") {
    errors[errors.length] = LAT_LON_FORMAT_ERROR;
  }

  // * Updated validation's logic to fulfill requirements
  if (effortData.lat_long_format === "Decimal Degrees") {
    if (effortData.latitude_or_loran1.decimal_degrees === "") {
      errors[errors.length] = LAT_DECIMAL_DEGREES_EMPTY;
    }
    if (effortData.longitude_or_loran2.decimal_degrees === "") {
      errors[errors.length] = LON_DECIMAL_DEGREES_EMPTY;
    }

    if (
      !regex_dec_degrees.test(effortData.latitude_or_loran1.decimal_degrees) &&
      !regex_dec_degrees.test(effortData.longitude_or_loran2.decimal_degrees)
    ) {
      errors[errors.length] = MINIMUM_DECIMAL_ERROR;
    } else if (!regex_dec_degrees.test(effortData.latitude_or_loran1.decimal_degrees)) {
      errors[errors.length] = MINIMUM_LAT_DECIMAL_ERROR;
    } else if (!regex_dec_degrees.test(effortData.longitude_or_loran2.decimal_degrees)) {
      errors[errors.length] = MINIMUM_LON_DECIMAL_ERROR;
    }

    if (!regex_latitude.test(effortData.latitude_or_loran1.decimal_degrees)) {
      errors[errors.length] = "Invalid Latitude";
    }
    if (!regex_longitude.test(effortData.longitude_or_loran2.decimal_degrees)) {
      errors[errors.length] = "Invalid Longitude";
    }
  }
  if (effortData.lat_long_format === "Degrees Decimal Minutes") {
    if (effortData.latitude_or_loran1.degrees_decimal_minutes.degrees === "") {
      errors[errors.length] = "No Latitude degrees provided";
    }
    if (effortData.latitude_or_loran1.degrees_decimal_minutes.minutes === "") {
      errors[errors.length] = "No Latitude decimal minutes provided";
    }
    if (effortData.longitude_or_loran2.degrees_decimal_minutes.degrees === "") {
      errors[errors.length] = "No Longitude degrees provided";
    }
    if (effortData.longitude_or_loran2.degrees_decimal_minutes.minutes === "") {
      errors[errors.length] = "No Longitude decimal minutes provided";
    }
    // Updating regex expression to validate
    regex_minutes = /^-?([0-5]?[0-9]|[1-9][0-9])(\.{1}\d{1,6})?$/;
    if (
      !regex_lat_degrees.test(
        effortData.latitude_or_loran1.degrees_decimal_minutes.degrees
      )
    ) {
      errors[errors.length] = "Invalid Latitude degrees ";
    }
    if (
      !regex_long_degrees.test(
        effortData.longitude_or_loran2.degrees_decimal_minutes.degrees
      )
    ) {
      errors[errors.length] = "Invalid Longitude degrees";
    }
    if (
      !regex_minutes.test(effortData.latitude_or_loran1.degrees_decimal_minutes.minutes)
    ) {
      errors[errors.length] = "Invalid Latitude minutes";
    }
    if (
      !regex_minutes.test(effortData.longitude_or_loran2.degrees_decimal_minutes.minutes)
    ) {
      errors[errors.length] = "Invalid Longitude minutes";
    }
  }
  if (effortData.lat_long_format === "Degrees Minutes Seconds") {
    if (effortData.latitude_or_loran1.degrees_minutes_seconds.degrees === "") {
      errors[errors.length] = "No Latitude degrees provided";
    }
    if (effortData.latitude_or_loran1.degrees_minutes_seconds.minutes === "") {
      errors[errors.length] = "No Latitude minutes provided";
    }
    if (effortData.latitude_or_loran1.degrees_minutes_seconds.seconds === "") {
      errors[errors.length] = "No Latitude seconds provided";
    }
    if (effortData.longitude_or_loran2.degrees_minutes_seconds.degrees === "") {
      errors[errors.length] = "No Longitude degrees provided";
    }
    if (effortData.longitude_or_loran2.degrees_minutes_seconds.minutes === "") {
      errors[errors.length] = "No Longitude minutes provided";
    }
    if (effortData.longitude_or_loran2.degrees_minutes_seconds.seconds === "") {
      errors[errors.length] = "No Longitude seconds provided";
    }
    if (
      !regex_lat_degrees.test(
        effortData.latitude_or_loran1.degrees_minutes_seconds.degrees
      )
    ) {
      errors[errors.length] = "Invalid Latitude degrees";
    }
    if (
      !regex_long_degrees.test(
        effortData.longitude_or_loran2.degrees_minutes_seconds.degrees
      )
    ) {
      errors[errors.length] = "Invalid Longitude degrees";
    }
    if (
      !regex_minutes.test(effortData.latitude_or_loran1.degrees_minutes_seconds.minutes)
    ) {
      errors[errors.length] = "Invalid Latitude minutes";
    }
    if (
      !regex_minutes.test(effortData.longitude_or_loran2.degrees_minutes_seconds.minutes)
    ) {
      errors[errors.length] = "Invalid Longitude minutes";
    }
    if (
      !regex_minutes.test(effortData.latitude_or_loran1.degrees_minutes_seconds.seconds)
    ) {
      errors[errors.length] = "Invalid Latitude seconds";
    }
    if (
      !regex_minutes.test(effortData.longitude_or_loran2.degrees_minutes_seconds.seconds)
    ) {
      errors[errors.length] = "Invalid Longitude seconds";
    }
  }
  return errors;
};

export const validateEffortSet4 = function (effortData) {
  let errors = [];
  if (
    Number.isNaN(Number(effortData.numTrapsInWater)) ||
    effortData.numTrapsInWater === ""
  ) {
    errors.push(getErrorText("effort", "numTrapsInWater", TRAPS_IN_WATER_EMPTY));
  }
  if (!Number.isInteger(Number(effortData.numTrapsInWater))) {
    errors.push(getErrorText("effort", "numTrapsInWater", TRAPS_IN_WATER_FORMAT));
  }
  if (Number.isNaN(Number(effortData.numBuoyLines)) || effortData.numBuoyLines === "") {
    errors.push(getErrorText("effort", "numBuoyLines", LINES_IN_WATER_EMPTY));
  }
  if (!Number.isInteger(Number(effortData.numBuoyLines))) {
    errors.push(getErrorText("effort", "numBuoyLines", LINES_IN_WATER_FORMAT));
  }
  if (
    Number.isNaN(Number(effortData.numTrapsHauled)) ||
    effortData.numTrapsHauled === "" ||
    effortData.numTrapsHauled === null
  ) {
    errors.push(getErrorText("effort", "numTrapsHauled", TRAPS_PER_EFFORT_EMPTY));
  }
  if (!Number.isInteger(Number(effortData.numTrapsHauled))) {
    errors.push(getErrorText("effort", "numTrapsHauled", TRAPS_PER_EFFORT_FORMAT));
  }
  if (
    Number.isNaN(Number(effortData.stringsHauled)) ||
    effortData.stringsHauled === "" ||
    effortData.stringsHauled === null
  ) {
    errors.push(getErrorText("effort", "stringsHauled", STRINGS_HAULED_EMPTY));
  }
  if (!Number.isInteger(Number(effortData.stringsHauled))) {
    errors.push(getErrorText("effort", "stringsHauled", STRINGS_HAULED_FORMAT));
  }
  if (
    Number.isNaN(Number(effortData.numTrapsPerString)) ||
    effortData.numTrapsPerString === ""
  ) {
    errors.push(getErrorText("effort", "numTrapsPerString", TRAPS_PER_STRING_EMPTY));
  }
  if (!Number.isInteger(Number(effortData.numTrapsPerString))) {
    errors.push(getErrorText("effort", "numTrapsPerString", TRAPS_PER_STRING_FORMAT));
  }
  if (Number.isNaN(Number(effortData.avgSoakTime)) || effortData.avgSoakTime === "") {
    errors.push(getErrorText("effort", "avgSoakTime", AVG_SOAK_TIME_EMPTY));
  }
  if (
    !Number.isInteger(Number(effortData.avgSoakTime)) &&
    isNaN(parseFloat(Number(effortData.avgSoakTime)))
  ) {
    errors.push(getErrorText("effort", "avgSoakTime", AVG_SOAK_TIME_FORMAT));
  }
  const avgSoakTime = effortData.avgSoakTime.split(".");
  if (avgSoakTime.length === 2 && avgSoakTime[1].length > 2) {
    errors.push(getErrorText("effort", "avgSoakTime", AVG_SOAK_TIME_MIN_FORMAT));
  }

  return errors;
};
